<h1 mat-dialog-title style="display: flex; margin: 10px;">
  <ng-container>
    @if (IsNewVendor) {
      <span style="flex: 1;">Create Vendor</span>
    }
    @if (!IsNewVendor) {
      <span style="flex: 1;">Edit Vendor - {{Vendor.Name}} ({{Vendor.Code}})</span>
    }

    <span>{{Vendor.Active ? "Active" : "Inactive"}}</span> &nbsp;
    <mat-slide-toggle color="accent" [disabled]="!Vendor.Id || !UserIsAdmin" [checked]="Vendor.Active" (change)="ToggleActive(vendorEditForm)">
    </mat-slide-toggle>
  </ng-container>
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow class="vendor-detail-modal">
  <form name="vendor-edit-form" #vendorEditForm="ngForm" style="padding-bottom: 15px;">
    <mat-tab-group [(selectedIndex)]="selectedTab">
      <mat-tab ngModelGroup="general" #generalTab="ngModelGroup">
        <ng-template mat-tab-label>
          @if (TabHasErrors(generalTab)) {
            <i class="fa fa-exclamation-circle" style="padding-right: 5px; color: red"></i>
          }
          <span [style.color]="TabHasErrors(generalTab) ? 'red' : 'rgba(0,0,0,.87)'">General</span>
        </ng-template>

        <div class="row">
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input matInput required name="vendor-name" [disabled]="!UserIsAdmin" #vendorName="ngModel" [(ngModel)]="Vendor.Name">
              @if (vendorName.errors?.required) {
                <mat-error>
                  Vendor Name is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Code</mat-label>
              <input matInput name="code" [(ngModel)]="Vendor.Code" [disabled]="!UserIsAdmin" maxlength="20">
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Type</mat-label>
              <mat-select panelClass="standard-modal-panel" required [(ngModel)]="Vendor.VendorTypeId" #vendorType="ngModel" name="vendorType" [disabled]="!UserIsAdmin">
                @for (s of Dropdowns.VendorTypes; track s) {
                  <mat-option [value]="s.TypeId">{{s.Description}}</mat-option>
                }
              </mat-select>
              @if (vendorType.errors?.required) {
                <mat-error>
                  Vendor Type is required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label>Address 1</mat-label>
                  <input matInput required #vendorAddress1="ngModel" name="address1" [(ngModel)]="Vendor.AddressLine1" [disabled]="!UserIsAdmin">
                  @if (vendorAddress1.errors?.required) {
                    <mat-error>
                      Address 1 is required
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label>Address 2</mat-label>
                  <input matInput name="address2" [(ngModel)]="Vendor.AddressLine2" [disabled]="!UserIsAdmin">
                </mat-form-field>
              </div>
              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label>Address 3</mat-label>
                  <input matInput name="address3" [(ngModel)]="Vendor.AddressLine3" [disabled]="!UserIsAdmin">
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                @if (UserIsAdmin) {
                  <mat-form-field>
                    <mat-label>Country</mat-label>
                    <ftms-typeahead #country="ngModel" name="country" [(ngModel)]="Vendor.CountryId" [required]="true" [items]="Dropdowns.Countries" (optionSelected)="onCountrySelected($event)"></ftms-typeahead>
                    @if (country.errors?.required) {
                      <mat-error>
                        Country is required
                      </mat-error>
                    }
                  </mat-form-field>
                }
                @if (!UserIsAdmin) {
                  <mat-form-field>
                    <mat-label>Country</mat-label>
                    <mat-select panelClass="standard-modal-panel" [(ngModel)]="Vendor.CountryId" name="country" disabled>
                      @for (t of Dropdowns.Countries; track t) {
                        <mat-option [value]="t.Item">{{t.DisplayText}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              <div class="col-sm-6">
                @if (UserIsAdmin) {
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <ftms-typeahead #vendorSubdivision name="subdivision" [(ngModel)]="Vendor.SubdivisionId" [items]="Dropdowns.Subdivisions"></ftms-typeahead>
                  </mat-form-field>
                }
                @if (!UserIsAdmin) {
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select panelClass="standard-modal-panel" [(ngModel)]="Vendor.SubdivisionId" disabled name="subdivision-select">
                      @for (t of Dropdowns.Subdivisions; track t) {
                        <mat-option [value]="t.Item">{{t.DisplayText}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <mat-form-field>
                  <mat-label>City</mat-label>
                  <input matInput required name="city" #city="ngModel" [(ngModel)]="Vendor.City" [disabled]="!UserIsAdmin">
                  @if (city.errors?.required) {
                    <mat-error>
                      City is <strong>required</strong>
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-sm-6">
                <mat-form-field>
                  <mat-label>Zip</mat-label>
                  <input matInput name="zip" [(ngModel)]="Vendor.Zip" [disabled]="!UserIsAdmin">
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Phone</mat-label>
              <input matInput name="phone" [(ngModel)]="Vendor.Phone" [disabled]="!UserIsAdmin">
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Fax</mat-label>
              <input matInput name="fax" [(ngModel)]="Vendor.Fax" [disabled]="!UserIsAdmin">
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput name="email" [(ngModel)]="Vendor.Email" [disabled]="!UserIsAdmin">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Purchase Order Required</mat-label>
              <mat-select panelClass="standard-modal-panel" required [(ngModel)]="Vendor.Po" #po="ngModel" name="Po" [disabled]="!UserIsAdmin">
                @for (option of BOOLEAN_DROPDOWN; track option) {
                  <mat-option [value]="option.value">{{option.name}}</mat-option>
                }
              </mat-select>
              @if (po.errors?.required) {
                <mat-error>
                  PO is required
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Purchase Order Comment</mat-label>
              <input matInput name="PoComment" [(ngModel)]="Vendor.PoComment" [disabled]="!UserIsAdmin">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>Agreement Required</mat-label>
              <mat-select panelClass="standard-modal-panel" required [disabled]="!UserIsAdmin" [(ngModel)]="Vendor.AgreementRequired" #agreementRequired="ngModel" name="agreementRequired" (selectionChange)="Vendor.AgreementNotRequiredReason = ''">
                @for (option of BOOLEAN_DROPDOWN; track option) {
                  <mat-option [value]="option.value">{{option.name}}</mat-option>
                }
              </mat-select>
              @if (agreementRequired.errors?.required) {
                <mat-error>
                  Agreement Required is required
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field>
              <mat-label>If no, reason</mat-label>
              <input matInput name="agreementNotRequiredReason" [disabled]="Vendor.AgreementRequired || !UserIsAdmin" [required]="!Vendor.AgreementRequired" [(ngModel)]="Vendor.AgreementNotRequiredReason">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field>
              <mat-label>Comments</mat-label>
              <textarea matInput name="vendorComments" #vendorComments="ngModel" [(ngModel)]="Vendor.VendorComments" [disabled]="!UserIsAdmin"></textarea>
            </mat-form-field>
          </div>
        </div>

      </mat-tab>

      <!--Contact Tab-->
      <mat-tab ngModelGroup="{{contactGroup}}" #contactsTab="ngModelGroup">
        <ng-template mat-tab-label>
          @if (TabHasErrors(contactsTab)) {
            <i class="fa fa-exclamation-circle" style="padding-right: 5px; color: red"></i>
          }
          <span [style.color]="TabHasErrors(contactsTab) ? 'red' : 'rgba(0,0,0,.87)'">Contacts</span>
        </ng-template>
        <div class="row">
          <div class="col-sm-12">
            @for (contact of Vendor.Contacts; track contact) {
              <mat-card>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-8">
                      <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput required name="contact-name{{contact.RecId}}" #contactName="ngModel" [(ngModel)]="contact.Name" [disabled]="!UserIsAdmin">
                        @if (contactName.errors?.required) {
                          <mat-error>
                            Contact Name is <strong>required</strong>
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <div class="contact-active-container">
                        @if (Vendor.Id != null) {
                          <section class="mat-mdc-checkbox-section">
                            <mat-checkbox name="contact-active{{contact.RecId}}" [disabled]="!UserIsAdmin" [(ngModel)]="contact.Active">Active</mat-checkbox>
                          </section>
                        }
                        <span style="flex: 1 1 auto;"></span>
                        <button mat-mini-fab type="button" (click)="RemoveContact(contact)" [disabled]="!UserIsAdmin || contact.TrialAssociated">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput name="contact-phone{{contact.RecId}}" [(ngModel)]="contact.Phone" [disabled]="!UserIsAdmin">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>Fax</mat-label>
                        <input matInput name="contact-fax{{contact.RecId}}" [(ngModel)]="contact.Fax" [disabled]="!UserIsAdmin">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput required name="contact-email{{contact.RecId}}" #contactEmail="ngModel" [(ngModel)]="contact.Email" [disabled]="!UserIsAdmin">
                        @if (contactEmail.errors?.required) {
                          <mat-error>
                            Contact Email is <strong>required</strong>
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field>
                        <mat-label>Address</mat-label>
                        <input matInput required #contactAddress1="ngModel" name="contact-address1{{contact.RecId}}" [(ngModel)]="contact.AddressLine1" [disabled]="!UserIsAdmin">
                        @if (contactAddress1.errors?.required) {
                          <mat-error>
                            Address 1 is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field>
                        <mat-label>Address 2</mat-label>
                        <input matInput name="contact-address2{{contact.RecId}}" [(ngModel)]="contact.AddressLine2" [disabled]="!UserIsAdmin">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field>
                        <mat-label>Address 3</mat-label>
                        <input matInput name="contact-address3{{contact.RecId}}" [(ngModel)]="contact.AddressLine3" [disabled]="!UserIsAdmin">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>Country</mat-label>
                        <mat-select panelClass="standard-modal-panel" [(ngModel)]="contact.CountryId" #country="ngModel" name="country{{contact.RecId}}" required disabled>
                          @for (s of Dropdowns.Countries; track s) {
                            <mat-option [value]="s.Item">{{s.DisplayText}}</mat-option>
                          }
                        </mat-select>
                        @if (country.errors?.required) {
                          <mat-error>
                            Country is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>State</mat-label>
                        @if (UserIsAdmin) {
                          <ftms-typeahead #subdivision name="subdivision{{contact.RecId}}" [(ngModel)]="contact.SubdivisionId" [items]="Dropdowns.Subdivisions"></ftms-typeahead>
                        }
                        @if (!UserIsAdmin) {
                          <mat-select panelClass="standard-modal-panel" [(ngModel)]="contact.SubdivisionId" disabled name="subdivion-select-{{contact.RecId}}">
                            @for (t of Dropdowns.Subdivisions; track t) {
                              <mat-option [value]="t.Item">{{t.DisplayText}}</mat-option>
                            }
                          </mat-select>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>City</mat-label>
                        <input matInput required name="contact-city{{contact.RecId}}" #contactCity="ngModel" [(ngModel)]="contact.City" [disabled]="!UserIsAdmin">
                        @if (contactCity.errors?.required) {
                          <mat-error>
                            City is <strong>required</strong>
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field>
                        <mat-label>Zip</mat-label>
                        <input matInput name="zip{{contact.RecId}}" [(ngModel)]="contact.Zip" [disabled]="!UserIsAdmin">
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" style="margin-top: 10px;">
            <button mat-raised-button type="button" (click)="AddContact()" [disabled]="!UserIsAdmin">
              <mat-icon>add</mat-icon>
              <b>&nbsp;Add Contact</b>
            </button>
          </div>
        </div>
      </mat-tab>

      <!--Agreement Tab-->
      <mat-tab ngModelGroup="agreements" #agreementsTab="ngModelGroup">
        <ng-template mat-tab-label>
          @if (TabHasErrors(agreementsTab)) {
            <i class="fa fa-exclamation-circle" style="padding-right: 5px; color: red"></i>
          }
          <span [style.color]="TabHasErrors(agreementsTab) ? 'red' : 'rgba(0,0,0,.87)'">Agreements</span>
        </ng-template>

        <div class="row">
          <div class="col-sm-12">
            <button mat-raised-button type="button" class="pull-right" (click)="AddAgreement()" [disabled]="!Vendor.AgreementRequired || !UserIsAdmin||!Vendor.Active">
              <mat-icon>add</mat-icon>
              Add Agreement
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="mat-elevation-z8" style="margin-top: 8px;">
              <table mat-table class="mat-mdc-table-medium table-compact-headers" [dataSource]="Agreements" style="max-height: 400px;">
                <ng-container matColumnDef="year">
                  <th mat-header-cell *matHeaderCellDef>Year</th>
                  <td mat-cell *matCellDef="let row" style="width: 80px;">{{row.CreatedDate | date:'y'}}</td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let row" style="width: 90px;">{{row.AgreementTypeName}}</td>
                </ng-container>
                <ng-container matColumnDef="agreementNumber">
                  <th mat-header-cell *matHeaderCellDef>Agreement #</th>
                  <td mat-cell *matCellDef="let row" style="max-width: 350px;" matTooltip="{{row.AgreementNumber}}">
                    {{row.AgreementNumber}}
                    @if (row.Active == true) {
                      <span class="badge badge-primary" style="margin-left: 10px;">Active</span>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="from">
                  <th mat-header-cell *matHeaderCellDef>From</th>
                  <td mat-cell *matCellDef="let row" style="width: 110px;">{{row.EffectiveStartDate | date:'d-LLL-y'}}</td>
                </ng-container>
                <ng-container matColumnDef="to">
                  <th mat-header-cell *matHeaderCellDef>To</th>
                  <td mat-cell *matCellDef="let row" style="width: 110px;">{{row.EffectiveEndDate | date:'d-LLL-y'}}</td>
                </ng-container>
                <ng-container matColumnDef="paymentPlan">
                  <th mat-header-cell *matHeaderCellDef>Payment Plan</th>
                  <td mat-cell *matCellDef="let row" style="width: 110px;">{{row.PaymentPlanName}}</td>
                </ng-container>
                <ng-container matColumnDef="timeline">
                  <th mat-header-cell *matHeaderCellDef>Timeline</th>
                  <td mat-cell *matCellDef="let row" style="width: 60px;">{{row.Timeline}}</td>
                </ng-container>
                <ng-container matColumnDef="comments">
                  <th mat-header-cell *matHeaderCellDef>Comments</th>
                  <td mat-cell *matCellDef="let row" class="auto-ellipsis" style="max-width: 250px;" matTooltip="{{row.Comments}}">{{row.Comments}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['year', 'type', 'agreementNumber', 'from', 'to', 'paymentPlan', 'timeline', 'comments']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['year', 'type', 'agreementNumber', 'from', 'to', 'paymentPlan', 'timeline', 'comments'];"
                  [class.selected]="agreementSelection.isSelected(row)"
                  (click)="agreementSelection.toggle(row)"
                (dblclick)="EditAgreement(row)"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>

      <!--Quotes Tab-->
      <mat-tab ngModelGroup="quotes" #quotesTab="ngModelGroup">
        <ng-template mat-tab-label>
          @if (TabHasErrors(quotesTab)) {
            <i class="fa fa-exclamation-circle" style="padding-right: 5px; color: red"></i>
          }
          <span [style.color]="TabHasErrors(quotesTab) ? 'red' : 'rgba(0,0,0,.87)'">Quotes</span>
        </ng-template>

        <div class="row">
          <div class="col-sm-8">
            <h4>Vendor Quotes</h4>
            <vendor-quote-filter [VendorId]="Vendor.Id"
              (YearSelected)="onQuoteYearFilterSelected($event)"
              (FieldScientistSelected)="onFieldScientistFilterSelected($event)"
            (ContactSelected)="onContactFilterSelected($event)"></vendor-quote-filter>
          </div>
          <div class="col-sm-4">
            <button mat-raised-button type="button" class="pull-right" style="margin-top: 5px;" (click)="AddQuote()" [disabled]="!Vendor.Active||isFromQuote">
              <mat-icon>add</mat-icon>
              Create FSPS Quote
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="mat-elevation-z8" style="margin-top: 8px;">
              <table mat-table class="mat-mdc-table-medium table-compact-headers" [dataSource]="Quotes">
                <ng-container matColumnDef="quoteNumber">
                  <th mat-header-cell *matHeaderCellDef>Quote #</th>
                  <td mat-cell *matCellDef="let row" style="width: 120px;">{{row.QuoteNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="year">
                  <th mat-header-cell *matHeaderCellDef>Year</th>
                  <td mat-cell *matCellDef="let row" style="width: 60px;">{{row.Year}}</td>
                </ng-container>
                <ng-container matColumnDef="fieldScientist">
                  <th mat-header-cell matTooltip=">Trial/Non-Trial Responsible" *matHeaderCellDef>Trial/Non-Trial Investigator</th>
                  <td mat-cell *matCellDef="let row">{{row.FieldScientistName}}</td>
                </ng-container>
                <ng-container matColumnDef="vendorContact">
                  <th mat-header-cell *matHeaderCellDef>Contact (Vendor)</th>
                  <td mat-cell *matCellDef="let row" style="width: 110px;">{{row.ContactName}}</td>
                </ng-container>
                <ng-container matColumnDef="trialNonTrial">
                  <th mat-header-cell *matHeaderCellDef>Trial/Non-Trial</th>
                  <td mat-cell *matCellDef="let row" style="width: 110px;">{{ row.TrialCount ? row.TrialCount + " Trials" : null }}@if (row.TrialCount && row.NontrialCount) {
                    <br>
                    }{{ row.NontrialCount ? row.NontrialCount + " Non-Trials" : null }}</td>
                  </ng-container>
                  <ng-container matColumnDef="committed">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right">Total Committed</th>
                    <td mat-cell *matCellDef="let row" style="max-width: 250px; text-align: right">{{row.TotalCommitted != null ? (row.TotalCommitted | number) + " " + row.CurrencyName : null}}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell class="auto-ellipsis" *matCellDef="let row">
                      <span title="{{GetQuoteStatus(row.Status)}}">
                        {{GetQuoteStatus(row.Status)}}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="PR">
                    <th mat-header-cell *matHeaderCellDef>PR</th>
                    <td mat-cell *matCellDef="let row" style="max-width: 250px;">{{row.PurchaseRequisitionNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="PO">
                    <th mat-header-cell *matHeaderCellDef>PO</th>
                    <td mat-cell *matCellDef="let row" style="max-width: 250px;">{{row.PurchaseOrderNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="document">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right">Documents</th>
                    <td mat-cell *matCellDef="let row" style="width: 110px; text-align: right">{{row.DocumentIds.length}}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['quoteNumber', 'year', 'fieldScientist', 'vendorContact', 'trialNonTrial', 'committed', 'status', 'PR', 'PO', 'document']"></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: ['quoteNumber', 'year', 'fieldScientist', 'vendorContact', 'trialNonTrial', 'committed', 'status', 'PR', 'PO', 'document'];"
                  (dblclick)="EditQuote(row.Id)"></tr>
                </table>
              </div>
            </div>
          </div>
        </mat-tab>

        <!--Invoice Tab-->
        <mat-tab ngModelGroup="invoice" #invoiceTab="ngModelGroup">
          <ng-template mat-tab-label>
            @if (TabHasErrors(invoiceTab)) {
              <i class="fa fa-exclamation-circle" style="padding-right: 5px; color: red"></i>
            }
            <span [style.color]="TabHasErrors(invoiceTab) ? 'red' : 'rgba(0,0,0,.87)'">Invoice/Payment</span>
          </ng-template>

          <div class="row">
            <div class="col-sm-8">
              <h4>Vendor Invoice/Payment</h4>
              <invoice-filter [VendorId]="Vendor.Id"
                (YearSelected)="onInvoiceYearFilterSelected($event)"
                (PurchaseOrderSelected)="onPurchaseOrderFilterSelected($event)"
              (PurchaseRequisitionSelected)="onPurchaseRequisitionFilterSelected($event)"></invoice-filter>
            </div>
            <div class="col-sm-4">
              <button mat-raised-button class="pull-right" type="button" (click)="AddInvoice()" [disabled]="!Vendor.Active || !UserIsAdmin||isFromInvoice">
                <mat-icon>add</mat-icon>
                Create FSPS Invoice
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="mat-elevation-z8" style="margin-top: 8px;">
                <table mat-table class="mat-mdc-table-medium table-compact-headers" [dataSource]="Invoices">
                  <ng-container matColumnDef="invoiceNumber">
                    <th mat-header-cell *matHeaderCellDef>Invoice #</th>
                    <td mat-cell *matCellDef="let row">{{row.InvoiceNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="po">
                    <th mat-header-cell *matHeaderCellDef>PO</th>
                    <td mat-cell *matCellDef="let row">{{row.PurchaseOrderNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="pr">
                    <th mat-header-cell *matHeaderCellDef>PR</th>
                    <td mat-cell *matCellDef="let row">{{row.PurchaseRequisitionNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="poEnd">
                    <th mat-header-cell *matHeaderCellDef>PO End</th>
                    <td mat-cell *matCellDef="let row">
                      @if (row.QuotePurchaseOrderEndDates.length == 1) {
                        {{row.QuotePurchaseOrderEndDates[0] | date:'d-LLL-y'}}
                      }
                      @if (row.QuotePurchaseOrderEndDates.length > 1) {
                        <em>Multiple</em>
                      }

                    </td>
                  </ng-container>
                  <ng-container matColumnDef="vendorInvoiceNumber">
                    <th mat-header-cell *matHeaderCellDef>Vendor Inv #</th>
                    <td mat-cell *matCellDef="let row">{{row.VendorAssignedInvoiceNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef>Due</th>
                    <td mat-cell *matCellDef="let row">{{row.DueDate | date:'d-LLL-y'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="invoiceTotal">
                    <th mat-header-cell *matHeaderCellDef>Inv Total</th>
                    <td mat-cell *matCellDef="let row">{{row.TotalInvoiced}} {{row.CurrencyName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="checkOrWireNumber">
                    <th mat-header-cell *matHeaderCellDef>Check/Wire</th>
                    <td mat-cell *matCellDef="let row">{{row.PaymentCheck}}</td>
                  </ng-container>
                  <ng-container matColumnDef="paidAmount">
                    <th mat-header-cell *matHeaderCellDef>Paid</th>
                    <td mat-cell *matCellDef="let row">{{row.PaymentDate | date:'d-LLL-y'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">{{GetInvoiceStatusDescription(row.InvoiceStatus)}}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['invoiceNumber', 'po', 'pr', 'poEnd', 'vendorInvoiceNumber', 'dueDate', 'invoiceTotal', 'checkOrWireNumber', 'paidAmount', 'status']"></tr>
                  <tr mat-row
                    *matRowDef="let row; columns: ['invoiceNumber', 'po', 'pr', 'poEnd', 'vendorInvoiceNumber', 'dueDate', 'invoiceTotal', 'checkOrWireNumber', 'paidAmount', 'status'];"
                  (dblclick)="EditInvoice(row.Id)"></tr>
                </table>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>

  <div mat-dialog-actions style="display: flex">
    @if (!IsNewVendor) {
      <div>
        <dl class="dl-horizontal modal-audit-info">
          @if (Vendor.CreatedByName != undefined && Vendor.CreatedByPersonId != 0) {
            <dt>Created:</dt>
          }
          @if (Vendor.CreatedByName != undefined && Vendor.CreatedByPersonId != 0) {
            <dd>{{ Vendor.CreateDate | date:'d-LLL-y' }} by {{ Vendor.CreatedByName }}</dd>
          }
          @if (Vendor.UpdatedByName != undefined && Vendor.UpdatedByPersonId != 0) {
            <dt>Updated:</dt>
          }
          @if (Vendor.UpdatedByName != undefined && Vendor.UpdatedByPersonId != 0) {
            <dd>{{ Vendor.UpdateDate | date:'d-LLL-y' }} by {{ Vendor.UpdatedByName }}</dd>
          }
        </dl>
      </div>
    }

    <span style="flex: 1 1 auto;"></span>
    <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
    <button mat-raised-button color="primary" (click)="SaveVendor(vendorEditForm, false)">Save</button>
    <button mat-raised-button color="primary" (click)="SaveVendor(vendorEditForm, true)">Save &amp; Close</button>
  </div>
